/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './dialog.less';
import svg_close from 'neuroglancer/static/close.svg';
import { makeElementUtil } from '../util/http_request';
// import {TrackableValue} from 'neuroglancer/trackable_value';
// import { ConfigStorage } from 'neuroglancer/viewer_state';
export interface DialogOptions {
    position?: string,
    unique?: boolean,
    canAdjustSize?: boolean
    className?: string,
    offsetCol?: number,
    exist?: boolean
}
export class Dialog {
    container: HTMLDivElement;
    buttonClose: HTMLElement;
    dlg_right: any;
    dlg_right_bottom: any;
    dlg_bottom: any;
    content: HTMLDivElement;
    buttonZoom: HTMLButtonElement;
    minWidth: number;
    minHeight: number;
    position:string;
    preDialogWidth = 0;
    preDialogHeight = 0;
    preDialogLeft = "0px";
    preDialogTop = "0px";
    mouseStart: any = {};
    divStart: any = {};
    rightStart: any = {};
    bottomStart: any = {};
    //用于解除事件绑定的一些参数
    temp1: any;
    temp2: any;
    temp3: any;
    temp4: any;
    temp5: any;
    temp6: any;
    // configStorage: ConfigStorage;
    constructor(parent?: HTMLElement, options: DialogOptions = {}) {
        const {position = 'right', unique = true, canAdjustSize = false, className = '', exist = true} = options
        if (unique && document.body.querySelector(".can_zoom_move_container_unique") && exist) {
            console.log(document.body.querySelector(".can_zoom_move_container_unique"))
            if(document.getElementsByClassName("can_zoom_move_container_unique"))document.body?.removeChild((document.body.querySelector(".can_zoom_move_container_unique") as HTMLDivElement));
        }
        this.position = position;
        let container = this.container = document.createElement('div');
        container.classList.add('can_zoom_move_container');
        if (unique) container.classList.add('can_zoom_move_container_unique');
        if (className) container.classList.add(className);
        document.body.appendChild(container);
        // container.onmousedown = (e) => this.moveHandler(e);

        this.minWidth = parseInt(getComputedStyle(container).minWidth)
        this.minHeight = parseInt(getComputedStyle(container).minHeight)
        if (parent) {
            // let info = parent.getBoundingClientRect()
            // const parentStyle = getComputedStyle(parent)
            // container.style.left = info.x + info.width + 'px';
            // container.style.top = info.y + parseInt(parentStyle.paddingTop) + 'px';
            this.initPosition(position, parent)
        }
        let header = makeElementUtil('div',['dlg_header'],{'style': 'width: 100%;height: 3rem;cursor: move;'});
        let dlg_top = document.createElement('div');
        dlg_top.classList.add('dlg_top');
        header.appendChild(dlg_top);
        container.appendChild(header);
        // dlg_top.addEventListener('onmousedown')
        header.onmousedown = (e) => this.moveHandler(e);

        let content = this.content = document.createElement('div');
        content.classList.add('can_zoom_move_content');
        container.appendChild(content);

        const buttonClose = this.buttonClose = document.createElement('div');
        buttonClose.classList.add('close-button');
        buttonClose.innerHTML = svg_close;
        container.appendChild(buttonClose);
        buttonClose.addEventListener('click', this.close)

        const buttonZoom = this.buttonZoom = document.createElement('button');
        buttonZoom.classList.add('zoom-button');
        buttonZoom.textContent = 'bigger/small';
        // container.appendChild(buttonZoom);
        buttonZoom.onclick = () => this.maxDialog();
        
        if (!canAdjustSize) return
        let dlg_right = this.dlg_right = document.createElement('div');
        dlg_right.classList.add('dlg_right');
        container.appendChild(dlg_right);
        dlg_right.onmousedown = (e) => this.dlgRightHandler(e);

        let dlg_right_bottom = this.dlg_right_bottom = document.createElement('div');
        dlg_right_bottom.classList.add('dlg_right_bottom');
        container.appendChild(dlg_right_bottom);
        dlg_right_bottom.onmousedown = (e) => this.dlgRightBottomHandler(e);

        let dlg_bottom = this.dlg_bottom = document.createElement('div');
        dlg_bottom.classList.add('dlg_bottom');
        container.appendChild(dlg_bottom);
        dlg_bottom.onmousedown = (e) => this.dlgBottomHandler(e);

    }
    initPosition (position: string, parent: HTMLElement) {
        let info = parent.getBoundingClientRect();
        if(parent.id)info = document.getElementById(parent.id)!.getBoundingClientRect();
        const parentStyle = getComputedStyle(parent)
        const container = this.container
        switch (position) {
            case 'right':
                container.style.left = info.x + info.width + 'px';
                container.style.top = info.y + parseInt(parentStyle.paddingTop ? parentStyle.paddingTop : '0') + 'px';
                break
            case 'bottom':
                container.style.left = info.x + 'px';
                container.style.top = info.y + parseInt(parentStyle.height??0) + parseInt(parentStyle.paddingTop ? parentStyle.paddingTop : '0') + 'px';
                break
            case 'left':
                container.style.left = (info.x - parseInt(parentStyle.paddingLeft ? parentStyle.paddingLeft : '0') + 2) + 'px';
                container.style.top = info.y + parseInt(parentStyle.paddingTop ? parentStyle.paddingTop : '0') + 'px';
                container.classList.add('position-left')
                break
            case 'top':
                container.style.left = (info.x - parseInt(parentStyle.paddingLeft ? parentStyle.paddingLeft : '0') + 2) + 'px';
                container.style.top = info.y + parseInt(parentStyle.paddingTop ? parentStyle.paddingTop : '0') + 'px';
                container.classList.add('position-top')
                break
            default:
                break
        }
    }
    close (e: Event) {
        e.stopPropagation()
    }
    maxDialog() {
        this.preDialogWidth = this.container.offsetWidth;
        this.preDialogHeight = this.container.offsetHeight;
        this.preDialogLeft = this.container.style.left;
        this.preDialogTop = this.container.style.top;
        this.container.style.left = 0 + "px";
        this.container.style.top = 0 + "px";
        this.container.style.width = window.innerWidth - 5 + "px";
        this.container.style.height = window.innerHeight - 5 + "px";
        this.buttonZoom.onclick = () => this.rebackDialog();
    }

    rebackDialog() {
        console.log(this)
        this.container.style.left = this.preDialogLeft;
        this.container.style.top = this.preDialogTop;
        this.container.style.width = this.preDialogWidth + "px";
        this.container.style.height = this.preDialogHeight + "px";
        this.buttonZoom.onclick = () => this.maxDialog();
    }

    // 移动
    moveHandler(e: any) {
        // if (!e.target.className.includes("dlg_header")) return;
        let container = this.container;
        var distanceX = e.clientX - this.container.offsetLeft;
        var distanceY = e.clientY - this.container.offsetTop;
        let temp = (evt: any) => {
            container.style.left = evt.clientX - distanceX + 'px';
            container.style.top = evt.clientY - distanceY + 'px';
        }
        document.addEventListener("mousemove", temp)
        let temp1 = () => {
            document.removeEventListener("mousemove", temp)
            document.removeEventListener("mouseup", temp1)
        }
        document.addEventListener("mouseup", temp1)
    }

    dlgRightHandler(e: any) {
        this.mouseStart.x = e.clientX;
        this.mouseStart.y = e.clientY;
        this.rightStart.x = this.dlg_right.offsetLeft;
        document.addEventListener("mousemove", this.temp1 = (e: any) => this.doDragToRightBottomToRight(e), true);
        document.addEventListener("mouseup", this.temp2 = () => this.stopDragToRightBottomToRight(), true);
    }

    doDragToRightBottomToRight(e: any) {
        let l = e.clientX - this.mouseStart.x + this.rightStart.x;
        let w = l + this.dlg_right_bottom.offsetWidth;
        if (w < this.dlg_right_bottom.offsetWidth) {
            w = this.dlg_right_bottom.offsetWidth;
        } else if (w > document.documentElement.clientWidth - this.container.offsetLeft) {
            w = document.documentElement.clientWidth - this.container.offsetLeft - 2;
        }
        if (w < this.minWidth) return;
        this.container.style.width = w + "px";
    };
    stopDragToRightBottomToRight() {
        document.removeEventListener("mousemove", this.temp1, true);
        document.removeEventListener("mouseup", this.temp2, true);
    };

    dlgBottomHandler(e: any) {
        this.mouseStart.x = e.clientX;
        this.mouseStart.y = e.clientY;
        this.bottomStart.y = this.dlg_bottom.offsetTop;
        document.addEventListener("mousemove", this.temp3 = (e: any) => this.doDragToRightBottomToBottom(e), true);
        document.addEventListener("mouseup", this.temp4 = () => this.stopDragToRightBottomToBottom(), true);
    };
    doDragToRightBottomToBottom(e: any) {
        let t = e.clientY - this.mouseStart.y + this.bottomStart.y;
        let h = t + this.dlg_right_bottom.offsetHeight;
        if (h < this.dlg_right_bottom.offsetHeight) {
            h = this.dlg_right_bottom.offsetHeight;
        }
        else if (h > document.documentElement.clientHeight - this.container.offsetTop) {
            h = document.documentElement.clientHeight - this.container.offsetTop - 2;
        }
        if (h < this.minHeight) return;
        this.container.style.height = h + "px";
    };
    stopDragToRightBottomToBottom() {
        document.removeEventListener("mousemove", this.temp3, true);
        document.removeEventListener("mouseup", this.temp4, true);
    };


    dlgRightBottomHandler(e: any) {
        this.mouseStart.x = e.clientX;
        this.mouseStart.y = e.clientY;
        this.divStart.x = this.dlg_right_bottom.offsetLeft;
        this.divStart.y = this.dlg_right_bottom.offsetTop;
        document.addEventListener("mousemove", this.temp5 = (e: any) => this.doDragToRightBottom(e), true);
        document.addEventListener("mouseup", this.temp6 = () => this.stopDragToRightBottom(), true);
    };
    doDragToRightBottom(e: any) {
        let l = e.clientX - this.mouseStart.x + this.divStart.x;
        let t = e.clientY - this.mouseStart.y + this.divStart.y;
        let w = l + this.dlg_right_bottom.offsetWidth;
        let h = t + this.dlg_right_bottom.offsetHeight;
        if (w < this.dlg_right_bottom.offsetWidth) {
            w = this.dlg_right_bottom.offsetWidth;
        }
        else if (w > document.documentElement.clientWidth - this.container.offsetLeft) {
            w = document.documentElement.clientWidth - this.container.offsetLeft - 2;
        }
        if (h < this.dlg_right_bottom.offsetHeight) {
            h = this.dlg_right_bottom.offsetHeight;
        }
        else if (h > document.documentElement.clientHeight - this.container.offsetTop) {
            h = document.documentElement.clientHeight - this.container.offsetTop - 2;
        }
        if (w < this.minWidth) return;
        this.container.style.width = w + "px";
        if (h < this.minHeight) return;
        this.container.style.height = h + "px";
    };
    stopDragToRightBottom() {
        document.removeEventListener("mousemove", this.temp5, true);
        document.removeEventListener("mouseup", this.temp6, true);
    };
}
